'use client';
import isEmpty from 'lodash/isEmpty';
/**
 * Processes and returns a value suitable for CSS (with a unit).
 */
export function getCssValue(value, unit) {
  if (unit === void 0) {
    unit = 'px';
  }
  if (value === undefined || value === null || value === '') {
    return '';
  }

  // If the value is 0, return it as a string without unit
  if (value === 0) {
    return '0';
  }

  // If the value is a number, append the default unit (defaults to 'px')
  if (typeof value === 'number') {
    return `${value}${unit}`;
  }

  // Return string values as is
  return value.toString();
}

/**
 * Merge multiple style objects, filtering out undefined values
 */
export function mergeStyles() {
  for (var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++) {
    styles[_key] = arguments[_key];
  }
  const mergedStyles = styles === null || styles === void 0 ? void 0 : styles.filter(Boolean).reduce((acc, style) => {
    if (!style) return acc;
    return {
      ...acc,
      ...style
    };
  }, {});
  return isEmpty(mergedStyles) ? undefined : mergedStyles;
}

/**
 * Create CSS variables for offset positioning
 */
export function createOffsetStyles(offset, prefix) {
  if (prefix === void 0) {
    prefix = '--rs-offset';
  }
  if (!offset) return undefined;
  const [x, y] = offset;
  return {
    [`${prefix}-x`]: getCssValue(x),
    [`${prefix}-y`]: getCssValue(y)
  };
}